<template>
    <div class="main-window-container">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'MainWindowContainer'
}
</script>

<style lang="scss" scoped>
    .main-window-container {
        display: flex;
        width: 100%;
        height: fit-content;
        min-height: 100%;
        flex-direction: column;
        background: #1C3B8D !important;
        align-items: center;
        box-sizing: border-box;
    }
</style>